<template>
  <div class="report-flow-list-wrapper">
     <van-nav-bar
      title="汇报管理趋势"
      @click-left="onClickLeft"
    >
      <template #left>
        <van-icon name="arrow-left" size="0.533rem" color="#333333"/>
      </template>
    </van-nav-bar>
    <div class="company-selection" @click="selectCompanyHandler">
      <span>{{ seletionData.company }}</span>
      <i class="iconfont icon-xiangxiajiantou company-arrow"></i>
    </div>
    <div class="date-selection-warpper">
      <div class="date-selection"> 
        <div class="flex-warpper add-border" @click="selectDateHandler">
          <span>{{ seletionData.selectedDate }}</span>
          <i class="iconfont icon-xiangxiajiantou"></i>
        </div>
      </div>
      <div class="date-show">
        <span>数据截止时间：</span>
        <span class="vei-mid">{{ seletionData.deadlineDate }}</span>
      </div>
    </div>
    <custom-table
      :columns="columns"
      :tableData="tableData"
      @sortFun="sortFun"
      :bodyHeight="68"
    >
    </custom-table>
    <van-action-sheet v-model="showDatePicker">
      <van-picker
        :default-index="defaultIndex"
        show-toolbar
        v-model="seletionData.selectedDate"
        :columns="yearOptions"
        @confirm="dateConfirm"
        @cancel="showDatePicker = false"
        ref="picker"
      />
    </van-action-sheet>
  </div>  
</template>

<script>
import { 
  getTrendYear
} from "@/axios/services"
import { Toast } from 'vant'

import CustomTable from "../commonComponents/CustomTable"

export default {
  data () {
    const columns = [
      {
        lable: "日期",
        align: "center",
        prop: "date"
      },
      {
        lable: "提交人数",
        align: "center",
        prop: "personNum",
        // isSort: true
      },
      {
        lable: "汇报数量",
        align: "center",
        prop: "approvalNum",
        // isSort: true
      },
    ]
    return {
      columns,
      seletionData: {
        selectedDate: new Date().getFullYear(),
        deadlineDate: this.getDate('yyyy-MM-dd', 'yesterday'),
        company: "深圳华瀚投资控股有限公司"
      },
      tableData: [
       
      ],
      yearOptions: (() => {
        let opts = []
        for (var i = 1990; i <= 2300; i++) {
          opts.push(i)
        }
        return opts
      })(),
      showDatePicker: false,
      isRefreshLoading: false,
      isFinished: false,
      isListloading: false,
      list: [],
      loading: false,
      finished: false,
      companyInfo: {
        scopeType: 0,
        companyId: localStorage.getItem("companyId") === "undefined" ? 
                  "cfe05dd2cedf4dd1ad9475d32838eaf9" : 
                  localStorage.getItem("companyId"),
        officeId: "1aba04d18e1a4f7f9a056c2144b8ac2e"
      },
      selectedCompany: [],
    }
  },
  created () {
    // this.queryTrendYear()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/select-data-range' || from.path === '/personal-report-board') {
      next(vm => {
        let params = null
        if (from.path === '/select-data-range') {
          params = from.params?.selectedData || []
        } else if (from.path === '/personal-report-board') {
          params = to.query?.seletionData ? JSON.parse(to.query?.seletionData) : []
          let selcetDate = to.query?.selectionDate
          vm.seletionData.selectedDate = selcetDate.slice(0, 4)
        }
        if (params.length) {
          vm.selectedCompany = params
          let selected = params[params.length -1]
          vm.seletionData.company = selected?.name
          vm.companyInfo.scopeType = selected?.type
          if (selected.type == 0 || selected.type == 1) {
            vm.companyInfo.companyId = selected.id
            vm.companyInfo.officeId = ""
          } else if (selected.type == 2) {
            vm.companyInfo.companyId = ""
            vm.companyInfo.officeId = selected.id
          }
        }
        vm.queryTrendYear()
      });
    } else {
      next()
    }
  },
  computed: {
    defaultIndex () {
      let index = this.yearOptions.findIndex(el => el === +this.seletionData.selectedDate)
      console.log(this.seletionData.selectedDate)
      return index
    }
  },
  methods: {
   getDate (format="yyyy-MM-dd", type) {
      let date = null
      type = type || 'today'
      let now = +Date.now()
      let oneDay = 1000 * 60 * 60 * 24
      let yesterday = now - oneDay
      const typeDes = ["yesterday", "today"]
      if (typeDes.includes(type)) {
        date =  type === 'yesterday' ? new Date(yesterday) : new Date()
      } else {
        date = new Date(type)
      }
      if (date.toString() === 'Invalid Date') {
        return
      } 
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        "S": date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ?
            (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
      }
      return format;
    },
    onClickLeft () {
     this.$router.back()
    },
    sortFun () {

    },
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
    },
    selectCompanyHandler () {
      this.$router.push({
        path: "select-data-range",
        query: {
          seletionData: JSON.stringify(this.selectedCompany)
        }
      })
    },
    dateConfirm (date) {
      this.showDatePicker = false
      if (this.seletionData.selectedDate === date) {
        return
      }
      this.seletionData.selectedDate = date
      this.queryTrendYear()
    },
    selectDateHandler () {
      this.showDatePicker = true
    },
    async queryTrendYear () {
      let [error, data] = await this.to(getTrendYear({
         scopeType: this.companyInfo.scopeType,
         companyId: this.companyInfo.companyId,
         officeId: this.companyInfo.officeId,
         currentPageSize: -1,
         date: this.seletionData.selectedDate + ""
      }))
      if (error) {
        return Toast.fail(error)
      }

      if (data) {
        this.tableData = data
      }
    },
    to (promise, errorFirst = true) {
      return promise.then(data => {
        let { code, msg, data: res } = data.data
        if (code == 0) {
          return errorFirst ? [null, res] : [null, res]
        } else {
          Toast.fail(msg)
          return errorFirst ? [null, null] : [null, null]
        }
      }).catch(err => {
        return errorFirst ? [err, null] : [null, err]
      }) 
    }
  },
  watch: {
    showDatePicker (status) {
      if (status) {
        let currentIndex = this.yearOptions.findIndex(el => el === +this.seletionData.selectedDate)
        this.$refs.picker && this.$refs.picker.setColumnIndex(0, currentIndex)
      }
    }
  },
  components: {
    CustomTable
  }
}
</script>

<style scoped>
.date-selection-warpper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  height: 44px;
  line-height: 44px;
  padding: 0 16px;
  margin: 10px 0;
}
.date-selection {
  display: flex;
}
.flex-warpper {
 display: flex;
  align-items: center;
}

.flex-warpper:nth-child(1) {
  margin-right: 20px;
}

.add-border {
  height: 26px;
  border: 1px solid #ddd;
  border-radius:4px;
  padding: 0 8px;
}

.date-selection span {
  color: #666;
  margin-right: 5px;
}

.date-show {
  font-size: 12px;
  color: #999;
}

.vei-mid {
  vertical-align: baseline;
}

.company-selection {
  text-align: center;
  position: relative;
  height: 44px;
  background-color: #fff;
  line-height: 44px;
}

.company-arrow {
  font-size: 18px;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
}
</style>